import { GetServerSidePropsContext } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Tabs from '@/components/Tabs/Tabs'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const CombosSubPage = ({ data }: GenericPageProps) => (
  <Main>
    <DefaultHead data={data} />
    <SimpleHeader className='mb-2'>{data.header}</SimpleHeader>
    <Tabs />
    <CardLists groupCardLists hideControls hideSidebar initCardLists={data.container.json_dict.cardlists} />
  </Main>
)

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/combos/${context.query.slug}.json`)

export default CombosSubPage
